export const licenseKey =
   'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjI5NWNkNjA1LWE4OGMtMTFlMi05ZTM4LTAwMjE5YjhiNTA0NyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.ikJx7fjJdxNCNbPRWaZjKCQKMbKA4T0ii281fRdMgcCsFcrXIxcZEBmqY7nHz8yWgmq1yvZk4eBrRr/N4XYV0upPMjGklqg1T738jdcMgWu4eUFz/2cBo9NUpgWBXFfDf6bWRw==';
